import { type ShippingRule } from '@hooks-api/types/dataModel/shipping'
import { type ShippingBaseStore } from '../types'

export const setAppliedShippingMethodId = (state: ShippingBaseStore, appliedShippingMethodId: number): ShippingBaseStore => {
  return {
    ...state,
    appliedShippingMethodId,
  }
}

export const setDeliveryDate = (state: ShippingBaseStore, deliveryDate: string): ShippingBaseStore => {
  return {
    ...state,
    deliveryDate,
  }
}

export const setDeliveryTimeSlot = (state: ShippingBaseStore, deliveryTimeSlot: string): ShippingBaseStore => {
  return {
    ...state,
    deliveryTimeSlot,
  }
}

export const getShippingInfo = (shippingRules: ShippingRule[], totalAmount: number) => {
  const shippingFees = shippingRules.flatMap(rules => rules.shipping_fees)
  // 排序運費規則依照 fee(最低要達到多少金額) 由小到大
  const sortedShippingFees = shippingFees.sort((a, b) => a.fee - b.fee)
  if (!sortedShippingFees[0]) {
    return {
      minShippingAmount: 0,
      minShippingFee: 0,
      isFixedFee: false,
    }
  }
  const bestThreshold = sortedShippingFees[0]
  const minShippingFee = bestThreshold.fee

  /** 固定運費 */
  const isFixedFee = bestThreshold.min_amount === 0 && (bestThreshold.max_amount === null || bestThreshold.max_amount === undefined)

  // 取得免運的最低門檻並依照 UI 顯示 (還差多少)
  const minShippingAmount = bestThreshold.min_amount - totalAmount
  return {
    minShippingAmount,
    minShippingFee,
    isFixedFee,
  }
}

export const getIsFreeShipping = (minShippingAmount: number | undefined, minShippingFee: number | undefined, shippingTotal: number | undefined) => {
  if (typeof minShippingAmount === 'undefined' || typeof minShippingFee === 'undefined' || typeof shippingTotal === 'undefined') {
    return false
  }
  const hasMetFreeShippingThreshold = minShippingAmount <= 0 && minShippingFee === 0
  const hasZeroShippingTotal = shippingTotal === 0
  return hasMetFreeShippingThreshold || hasZeroShippingTotal
}
